import checkIcon from '@/assets/icons/icon_tick-circle.svg'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './registrationSuccess.module.css'

export const RegistrationSuccess = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/campaigns', {
        replace: true,
        state: { registrationComplete: true },
      })
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className={styles.root}>
      <div className={styles.rightPane}>
        <img src={checkIcon} alt="Success" className={styles.icon} />
        <div className={styles.title}>Your Account is Ready!</div>
      </div>
    </div>
  )
}
